import React, { useState } from "react";
import AppText from "./AppText";
import { appStrings } from "./strings";
import { Link } from "react-router-dom";

import Button from "../../presentational/Button";
interface VerifyNonceProps {
    serverError: string;
    isLoading: boolean;
    email: string;
    isValidNonce: (nonce: string) => string | null;
    verifyNonce: (email: string, verificationCode: string) => void;
}

const VerifyNonce: React.FC<VerifyNonceProps> = ({ serverError, isLoading, email, isValidNonce, verifyNonce }) => {
    const [verificationCode, setVerificationCode] = useState("");

    const handleSubmit = () => {
        verifyNonce(email, verificationCode);
        return false;
    };

    const onVerificationCodeChanged: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setVerificationCode(e.target.value);
        if (isValidNonce(e.target.value)) {
            verifyNonce(email, e.target.value);
        }
    };

    return (
        <main>
            <div className="form-wrapper">
                <form className="form" onSubmit={handleSubmit}>
                    <h2 className="form-header">
                        <img className="form-header-logo" src="https://assets.careevolutionapps.com/CareEvolution/Images/MDHD/mdhd-blue-bug-logo-centered.svg" alt="MyDataHelps Designer Logo" />
                        <AppText textKey="verify-nonce-title" />
                    </h2>
                    <p>
                        <AppText textKey="verify-nonce-info" values={{ email: email }} />
                    </p>
                    {serverError && <p className="server-error">{serverError}</p>}
                    <div className="field-group">
                        <label>{appStrings["verification-code-label"]}</label>
                        <input
                            autoComplete="one-time-code"
                            className="autofocus admin-input"
                            disabled={isLoading}
                            onChange={onVerificationCodeChanged}
                            id="verificationCode"
                            type="tel"
                            value={verificationCode}
                            placeholder="123-123-1234"
                            spellCheck={false}
                            autoCapitalize="none"
                            autoCorrect="off"
                            autoFocus={true}
                            maxLength={12}
                            pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                        />
                    </div>
                    <Button
                        onClick={handleSubmit}
                        intent="primary"
                        disabled={!isValidNonce(verificationCode)}
                        loading={isLoading}
                        type="submit"
                    >
                        <span
                            dangerouslySetInnerHTML={{
                                __html: appStrings["next-label"],
                            }}
                        />
                    </Button>
                    {serverError && (
                        <Link className="editor-controls-button text-button" to={"/forgotPassword"}>
                            <AppText textKey="forgot-password-label" />
                        </Link>
                    )}
                    <Link className="editor-controls-button text-button" to={"/login"}>
                        <AppText textKey="back-to-login-label" />
                    </Link>
                </form>
            </div>
        </main>
    );
};

export default VerifyNonce;
